<template>
  <b-form-select :value="activeFloor" text-field="name" value-field="id" @change="change">
    <optgroup v-for="building in groupedFloors" :key="`building-${building.id}`" :label="building.name">
      <option :value="floor.id" :key="`floor-${floor.id}`" v-for="floor in building.floors">
        {{ floor.name }}
      </option>
    </optgroup>
  </b-form-select>
</template>

<script>
import { mapGetters } from 'vuex'

const FLOOR_STATUS_DRAFT = 0

export default {
  name: 'MapFloorSelect',
  props: {
    activeFloor: {
      type: [Number, String]
    },
    setDefault: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    ...mapGetters('floor', ['getBuildingPublishedFloors', 'floors']),
    ...mapGetters('building', ['buildings']),
    groupedFloors() {
      const defaultBuilding = { id: 0, name: 'Standalone Floors', floors: [] }

      const buildingsMap = this.floors.reduce((buildingsMap, floor) => {
        if (floor.status === FLOOR_STATUS_DRAFT) return buildingsMap

        const buildingId = floor.building_id ?? defaultBuilding.id
        if (!buildingsMap[buildingId]) {
          if (buildingId) {
            const building = this.buildings.find((v) => v.id === buildingId)
            buildingsMap[buildingId] = { id: buildingId, name: building?.name ?? '', floors: [] }
          } else {
            buildingsMap[buildingId] = defaultBuilding
          }
        }
        buildingsMap[buildingId].floors.push(floor)

        return buildingsMap
      }, {})

      const buildings = Object.values(buildingsMap)
        .map((building) => {
          building.floors.sort((a, b) => a.sort - b.sort)
          return building
        })
        .sort((a, b) => a.name.localeCompare(b.name))

      return buildings
    }
  },
  methods: {
    change(floorId) {
      this.$emit('change', floorId)
    },
    initFloor() {
      if (!this.activeFloor && this.setDefault) {
        let firstPublishedFloor = this.floors.find((floor) => floor.status)
        if (firstPublishedFloor) {
          this.change(firstPublishedFloor.id)
        }
      }
    }
  },
  watch: {
    activeFloor: {
      immediate: true,
      handler() {
        this.initFloor()
      }
    },
    floors: {
      immediate: true,
      handler() {
        this.initFloor()
      }
    }
  }
}
</script>

<style scoped></style>
